/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, TextField } from 'framework/ui/field';
import { Box } from '@mui/material';
import { getAmount } from 'domain/finance/ledger/shared/field/BalanceField';

const TotalFieldDecorator = ({ children, ...props }: any) => {
  const { getValue } = useFieldHelper(props);
  const value = getValue() as any;

  if (value) {
    if (props.source === 'totalGrossSalary') {
      return (
        <TextField
          {...props}
          value={
            <Box
              sx={{
                display: 'flex',
                div: {
                  marginRight: '16px',
                },
              }}
            >
              {!!value.USD && <div>{getAmount(value, 'USD')}</div>}
              {!!value.PLN && <div>{getAmount(value, 'PLN')}</div>}
              {!!value.BYR && <div>{getAmount(value, 'BYR')}</div>}
            </Box>
          }
        />
      );
    }

    return <TextField {...props} />;
  }

  return children;
};

export default TotalFieldDecorator;
